export default {
    'diagram11-3a1': {
        'diagram-number': '11.',
        'elements': {
            'one': 'Clouds that could produce rain contain micron-size droplets of water, kept aloft by updrafts',
            'two': 'To escape the updrafts, droplets must coalesce into ice pellets',
            'three': 'The droplets can’t coalesce without dust particles to serve as nuclei',
            'four': 'To get rain, we mimic the dust particles with silver iodide',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram11/i18n/en.js